// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file Options/ValidationFieldOptions.proto (syntax proto3)
/* eslint-disable */

import type { GenExtension, GenFile } from "@bufbuild/protobuf/codegenv2";
import { extDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";
import type { Empty, FieldOptions } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_descriptor, file_google_protobuf_empty } from "@bufbuild/protobuf/wkt";
import type { DurationGreaterThanOrEqualToValidationDto, DurationLessThanOrEqualToValidationDto, EmailAddressValidationDto, EmptyValidationDto, EnsureAfterValidationDto, GreaterThanOrEqualToValidationDto, GreaterThanValidationDto, IsDateAndTimeWithoutSecondsValidationDto, IsDateOnlyValidationDto, IsInEnumValidationDto, IsTimeWithoutSecondsValidationDto, LessThanOrEqualToValidationDto, LessThanValidationDto, MaximumCountValidationDto, MaximumLengthValidationDto, MinimumLengthValidationDto, NotEmptyValidationDto, NotNullValidationDto, NullValidationDto, RegularExpressionValidationDto } from "../Messages/Validation_pb";
import { file_Messages_Validation } from "../Messages/Validation_pb";

/**
 * Describes the file Options/ValidationFieldOptions.proto.
 */
export const file_Options_ValidationFieldOptions: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_descriptor, file_google_protobuf_empty, file_Messages_Validation]);

/**
 * Specifies that a string field must have a minimum length.
 *
 * @generated from extension: time_tracking.messages.validation.MinimumLengthValidationDto minimum_length = 4091200;
 */
export const minimum_length: GenExtension<FieldOptions, MinimumLengthValidationDto> = /*@__PURE__*/
  extDesc(file_Options_ValidationFieldOptions, 0);

/**
 * Specifies that a string field must have a maximum allowed length.
 *
 * @generated from extension: time_tracking.messages.validation.MaximumLengthValidationDto maximum_length = 4091201;
 */
export const maximum_length: GenExtension<FieldOptions, MaximumLengthValidationDto> = /*@__PURE__*/
  extDesc(file_Options_ValidationFieldOptions, 1);

/**
 * Specifies that a string field must contain a valid email address.
 *
 * @generated from extension: time_tracking.messages.validation.EmailAddressValidationDto email_address = 4091202;
 */
export const email_address: GenExtension<FieldOptions, EmailAddressValidationDto> = /*@__PURE__*/
  extDesc(file_Options_ValidationFieldOptions, 2);

/**
 * Specifies that a string, number or collection field must be empty.
 *
 * @generated from extension: time_tracking.messages.validation.EmptyValidationDto empty = 4091203;
 */
export const empty: GenExtension<FieldOptions, EmptyValidationDto> = /*@__PURE__*/
  extDesc(file_Options_ValidationFieldOptions, 3);

/**
 * Specifies that a string, number or collection field may not be empty.
 *
 * @generated from extension: time_tracking.messages.validation.NotEmptyValidationDto not_empty = 4091204;
 */
export const not_empty: GenExtension<FieldOptions, NotEmptyValidationDto> = /*@__PURE__*/
  extDesc(file_Options_ValidationFieldOptions, 4);

/**
 * Specifies that a string field must satisfy a given regular expression.
 *
 * @generated from extension: time_tracking.messages.validation.RegularExpressionValidationDto regular_expression = 4091205;
 */
export const regular_expression: GenExtension<FieldOptions, RegularExpressionValidationDto> = /*@__PURE__*/
  extDesc(file_Options_ValidationFieldOptions, 5);

/**
 * Specifies that a number field must have an exclusive upper bound.
 *
 * @generated from extension: time_tracking.messages.validation.LessThanValidationDto less_than = 4091206;
 */
export const less_than: GenExtension<FieldOptions, LessThanValidationDto> = /*@__PURE__*/
  extDesc(file_Options_ValidationFieldOptions, 6);

/**
 * Specifies that a number field must have an inclusive upper bound.
 *
 * @generated from extension: time_tracking.messages.validation.LessThanOrEqualToValidationDto less_than_or_equal_to = 4091207;
 */
export const less_than_or_equal_to: GenExtension<FieldOptions, LessThanOrEqualToValidationDto> = /*@__PURE__*/
  extDesc(file_Options_ValidationFieldOptions, 7);

/**
 * Specifies that a number field must have an exclusive lower bound.
 *
 * @generated from extension: time_tracking.messages.validation.GreaterThanValidationDto greater_than = 4091208;
 */
export const greater_than: GenExtension<FieldOptions, GreaterThanValidationDto> = /*@__PURE__*/
  extDesc(file_Options_ValidationFieldOptions, 8);

/**
 * Specifies that a number field must have an inclusive lower bound.
 *
 * @generated from extension: time_tracking.messages.validation.GreaterThanOrEqualToValidationDto greater_than_or_equal_to = 4091209;
 */
export const greater_than_or_equal_to: GenExtension<FieldOptions, GreaterThanOrEqualToValidationDto> = /*@__PURE__*/
  extDesc(file_Options_ValidationFieldOptions, 9);

/**
 * Specifies that a field must be null.
 *
 * @generated from extension: time_tracking.messages.validation.NullValidationDto null = 4091210;
 */
export const null$: GenExtension<FieldOptions, NullValidationDto> = /*@__PURE__*/
  extDesc(file_Options_ValidationFieldOptions, 10);

/**
 * Specifies that a field must not be null.
 *
 * @generated from extension: time_tracking.messages.validation.NotNullValidationDto not_null = 4091211;
 */
export const not_null: GenExtension<FieldOptions, NotNullValidationDto> = /*@__PURE__*/
  extDesc(file_Options_ValidationFieldOptions, 11);

/**
 * Specifies that a field must be a valid enum value.
 *
 * @generated from extension: time_tracking.messages.validation.IsInEnumValidationDto is_in_enum = 4091212;
 */
export const is_in_enum: GenExtension<FieldOptions, IsInEnumValidationDto> = /*@__PURE__*/
  extDesc(file_Options_ValidationFieldOptions, 12);

/**
 * Specifies that a collection must have a maximum allowed element count.
 *
 * @generated from extension: time_tracking.messages.validation.MaximumCountValidationDto maximum_count = 4091213;
 */
export const maximum_count: GenExtension<FieldOptions, MaximumCountValidationDto> = /*@__PURE__*/
  extDesc(file_Options_ValidationFieldOptions, 13);

/**
 * Specifies that a timestamp must only have a date and no time value.
 *
 * @generated from extension: time_tracking.messages.validation.IsDateOnlyValidationDto is_date_only = 4091214;
 */
export const is_date_only: GenExtension<FieldOptions, IsDateOnlyValidationDto> = /*@__PURE__*/
  extDesc(file_Options_ValidationFieldOptions, 14);

/**
 * Specifies that a timestamp or date time offset must only contain a date and time with seconds and milliseconds set to zero.
 *
 * @generated from extension: time_tracking.messages.validation.IsDateAndTimeWithoutSecondsValidationDto is_date_and_time_without_seconds = 4091215;
 */
export const is_date_and_time_without_seconds: GenExtension<FieldOptions, IsDateAndTimeWithoutSecondsValidationDto> = /*@__PURE__*/
  extDesc(file_Options_ValidationFieldOptions, 15);

/**
 * Specifies that a duration must only contain a time with seconds and milliseconds set to zero.
 *
 * @generated from extension: time_tracking.messages.validation.IsTimeWithoutSecondsValidationDto is_time_without_seconds = 4091216;
 */
export const is_time_without_seconds: GenExtension<FieldOptions, IsTimeWithoutSecondsValidationDto> = /*@__PURE__*/
  extDesc(file_Options_ValidationFieldOptions, 16);

/**
 * Specifies that a timestamp or date time offset must occur after a referenced timestamp or date time offset.
 *
 * @generated from extension: time_tracking.messages.validation.EnsureAfterValidationDto ensure_after = 4091217;
 */
export const ensure_after: GenExtension<FieldOptions, EnsureAfterValidationDto> = /*@__PURE__*/
  extDesc(file_Options_ValidationFieldOptions, 17);

/**
 * Specifies that a duration is less than or equal to a specified value.
 *
 * @generated from extension: time_tracking.messages.validation.DurationLessThanOrEqualToValidationDto duration_less_than_or_equal_to = 4091218;
 */
export const duration_less_than_or_equal_to: GenExtension<FieldOptions, DurationLessThanOrEqualToValidationDto> = /*@__PURE__*/
  extDesc(file_Options_ValidationFieldOptions, 18);

/**
 * Specifies that a duration is greater than or equal to a specified value.
 *
 * @generated from extension: time_tracking.messages.validation.DurationGreaterThanOrEqualToValidationDto duration_greater_than_or_equal_to = 4091219;
 */
export const duration_greater_than_or_equal_to: GenExtension<FieldOptions, DurationGreaterThanOrEqualToValidationDto> = /*@__PURE__*/
  extDesc(file_Options_ValidationFieldOptions, 19);

/**
 * Specifies that no child validator should be executed automatically for this field.
 * This special option is only allowed on fields that are of type message, repeated field or map.
 *
 * @generated from extension: google.protobuf.Empty disable_child_validation = 4091220;
 */
export const disable_child_validation: GenExtension<FieldOptions, Empty> = /*@__PURE__*/
  extDesc(file_Options_ValidationFieldOptions, 20);

